import { hash } from '../../hash';
export const isParticleAttachment = (node) => {
    return node.name !== undefined;
};
export const logNode = (treeNode) => {
    // Particle tree logging bypasses logging framework as it's
    // controlled by a dedicated flag
    console.log('[Renderer] New Furniture received', treeNode);
    const logRecursive = (treeNode) => {
        const hasAttached = treeNode.attachments.active.length > 0;
        const attachedNodes = hasAttached
            ? `, ${treeNode.attachments.active.length} attached nodes:`
            : '';
        const logString = `${treeNode.attachmentTag}: ${treeNode.id}${attachedNodes}`;
        hasAttached ? console.group(logString) : console.log(logString);
        if (treeNode.attachments.active.length) {
            treeNode.attachments.active.flatMap(attached => logRecursive(attached));
        }
        hasAttached && console.groupEnd();
    };
    logRecursive(treeNode);
};
/**
 * Generate a unique hash for a given particle tree node, using the unique particle id and the position / rotation.
 * This means a specific instance of an attachment can be compared against another tree directly.
 * @param treeNode the particle node to read from
 * @returns string SHA-256 hash
 */
export const transformHash = async (treeNode) => {
    const hashString = treeNode.id + JSON.stringify(treeNode.position) + JSON.stringify(treeNode.orientation);
    return hash(hashString);
};
export function getIds(tree) {
    return [tree.id, ...tree.attachments.active.flatMap(getIds)];
}
